module.exports = __webpack_public_path__ + "static/media/join-bg.27213c6c.jpg";